import { render, staticRenderFns } from "./BomDetailForm.vue?vue&type=template&id=00dc560f&scoped=true&"
import script from "./BomDetailForm.vue?vue&type=script&lang=js&"
export * from "./BomDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./BomDetailForm.vue?vue&type=style&index=0&id=00dc560f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc560f",
  null
  
)

export default component.exports